var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9013 5.07575L20.9034 5.07217C20.9234 5.04106 20.9411 5.00815 20.9551 4.97345C20.9596 4.96328 20.9614 4.95221 20.965 4.94174C20.974 4.91602 20.9832 4.89029 20.9883 4.86307C20.9946 4.83226 20.9964 4.80145 20.9976 4.77004C20.9979 4.76256 21 4.75508 21 4.74761C21 4.70782 20.9958 4.66744 20.988 4.62855C20.9862 4.61988 20.9827 4.6118 20.9806 4.60342C20.9734 4.57351 20.9653 4.5445 20.9533 4.51578C20.9506 4.5095 20.9468 4.50381 20.9438 4.49723C20.9147 4.43441 20.8765 4.37489 20.825 4.32314L17.1711 0.668636C16.9378 0.435013 16.5588 0.435013 16.3252 0.668636C16.0915 0.902258 16.0915 1.28096 16.3252 1.51458L18.959 4.14904L1.59827 4.14904C1.26802 4.14904 1 4.41707 1 4.74731C1 5.07755 1.26802 5.34557 1.59827 5.34557L18.9563 5.34557L16.3237 7.97884C16.09 8.21246 16.09 8.59116 16.3237 8.82478C16.5573 9.0584 16.9363 9.0584 17.1696 8.82478L20.8175 5.17626C20.8489 5.14605 20.8771 5.11255 20.9013 5.07575Z",
    fill: "#004BEC",
    stroke: "#004BEC",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActArrow);
export default __webpack_public_path__ + "static/media/act-arrow.ba78eed366bfdac6db29af7ba804c019.svg";
export { ForwardRef as ReactComponent };